module.exports = __webpack_public_path__ + "media/Macchione_PolodelGusto_2021_def.2b64d900.mp4";